import { render } from "./ButtonPrimary.vue?vue&type=template&id=70b4a986&scoped=true&ts=true"
import script from "./ButtonPrimary.vue?vue&type=script&lang=ts"
export * from "./ButtonPrimary.vue?vue&type=script&lang=ts"

import "./ButtonPrimary.vue?vue&type=style&index=0&id=70b4a986&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b4a986"]])

export default __exports__